import { useEffect, useState } from 'react';
import './index.css';
import axios from 'axios';
import { tryCatchJsonParse } from '../../utils/catch/tryCatchJson';
import { use } from 'react';
import { useQueryParms } from '../../hooks/useQueryParams';
import { useNavigate } from 'react-router-dom';
import { useGetGoldebBallInfo } from '../GoldenBallThrophyScreen/hooks/useGetGoldenBallInfo';
import { useGetPlayersNominated } from './hooks/useGetPlayerNominated';
import { adapterPositionLabel, getCurrentMedio, getLabelToVote, getPositionStatus, getTypeMedio } from './utils/medioTags';
import { useVoteRedirect } from './hooks/useVoteRedirect';
import GridPlayers from './components/GridPlayers';
import HeaderGoldenball from './components/HeaderGoldenball';
import { useHandlerVoting } from './hooks/useHandlerVoting';
import DefaultScreen from '../DefaultScreen';
import DescriptionLabel from './components/DescriptionLabel';
import CarouselPlayers from './components/CarouselPlayers';
import useIsMobileAndPortrait from '../../hooks/useIsMobile';
import LoadingVoteModal from './components/LoadingVoteModal';
import ConfirmVoteModal from './components/ConfirmVoteModal';


const GoldenBallVotedScreen = ()=>{
        const { goldenBallInfo, isLoading } = useGetGoldebBallInfo({phase:'nominates'});
        const { handleVoteByPlayer, hasSpecialVote, playersVoted, positionPlayer, isVoting, selectedPlayer, setSelectedPlayer } = useHandlerVoting({
            goldenBallInfo: goldenBallInfo, 
            phase:'nominate'})
        const { allPlayers } = useGetPlayersNominated({phase:'nominate'})
        const playerByPosition = allPlayers?.filter(player => player?.subPosition === positionPlayer)
        const isVotedEnable = goldenBallInfo?.isEnablePhase?.nominate?.vote
        useVoteRedirect({
        goldenBallInfo, 
        hasSpecialVote,
        playersVoted,
        targetPath: 'graphScreen',
        numberVoted: 6,

                    })
       const{ isMobile} =  useIsMobileAndPortrait()
    if(isLoading) return <LoadingVoteModal />
    if(!isVotedEnable) return <DefaultScreen title={`${goldenBallInfo?.name} ${goldenBallInfo?.year}`} description={'Se han termindo las votaciones pronto conoceremos los resultados'} />
    return(
        <div className='golden-ball-voted-screen-container' >
            <div className='golden-ball-voted-screen-subcontainer'>
                <HeaderGoldenball info={goldenBallInfo} isSpecialVote={hasSpecialVote} />
                <DescriptionLabel phase={'nominate'} position={getPositionStatus(playersVoted) }  />
                {
                    isMobile ? <CarouselPlayers players={playerByPosition} vote={setSelectedPlayer} /> : <GridPlayers players={playerByPosition} vote={setSelectedPlayer}  />
                }
                {
                    selectedPlayer && <ConfirmVoteModal vote={handleVoteByPlayer} player={selectedPlayer} cancel={() => setSelectedPlayer(null)} />
                }
                {isVoting  && <LoadingVoteModal />}
            </div>
        </div>

    )
}

export default  GoldenBallVotedScreen